import { render, staticRenderFns } from "./Heizenergie.vue?vue&type=template&id=66e35fe4&"
import script from "./Heizenergie.vue?vue&type=script&lang=js&"
export * from "./Heizenergie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports